import React from 'react';
import { MetricCard } from 'common/components';
import {
    getDashboardMetricId,
    getDashboardMetricTheme,
    getInfoDisplayValue,
    type InfoData,
} from './dashboardMetricCard.utils';

export type InfoItem = {
    key?: string;
    title: string;
    description?: string;
    data?: InfoData;
};

export type InfoCardsProps = {
    infos?: InfoItem[] | Record<string, InfoItem>;
};

const toInfoEntries = (infos: InfoItem[] | Record<string, InfoItem>): Array<InfoItem & { id: string }> => {
    if (Array.isArray(infos)) {
        return infos.map((info, index) => ({
            ...info,
            id: getDashboardMetricId(info.title, info.key || String(index)),
        }));
    }

    return Object.entries(infos).map(([key, info]) => ({
        ...info,
        id: getDashboardMetricId(info.title, info.key || key),
    }));
};

const InfoCards = ({ infos }: InfoCardsProps) => {
    if (!infos) return null;

    return (
        <>
            {toInfoEntries(infos).map((info) => {
                const displayValue = getInfoDisplayValue(info.data);
                const numericValue = typeof info.data === 'number' ? info.data : Number(displayValue);
                const isNumericCount =
                    typeof info.data === 'number' ||
                    (displayValue !== '' && Number.isFinite(numericValue) && String(numericValue) === displayValue);

                return (
                    <MetricCard
                        key={info.id}
                        id={info.id}
                        label={info.title}
                        tooltip={info.description}
                        theme={getDashboardMetricTheme(info.title, info.key)}
                        count={isNumericCount ? numericValue : 0}
                        primaryValue={isNumericCount ? undefined : displayValue}
                        showPercent={false}
                    />
                );
            })}
        </>
    );
};

export default InfoCards;
